// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-select {
  --vs-controls-size: 0.8;
  --vs-dropdown-option--active-bg: rgb(var(--color-secondary));
  --vs-actions-padding: 3px 3px 0 1px;
}
.v-select[alternative-indicator=true] .vs__open-indicator {
  fill: none;
  transition: none;
}
.v-select:not(.vs--disabled) .vs__dropdown-toggle {
  background: white;
}
.v-select[transparent] .vs__dropdown-toggle {
  background: transparent;
}
.vs--loading .vs__open-indicator {
  width: 2px;
}
.vs--single.vs--loading .vs__selected {
  position: relative;
}
.v-select[dense] {
  --vs-actions-padding: 1px 3px 0 0px;
}
.v-select[dense] .vs__selected-options {
  padding: 1px 2px 0 6px;
}
.v-select[rounded] .vs__dropdown-toggle {
  padding: 0 4px 0 6px;
}
.v-select[elevated] .vs__dropdown-toggle {
  box-shadow: 0px 2px 4px rgba(35, 17, 131, 0.16);
}
.v-select[dense].v-select[elevated] .vs__selected-options {
  padding: 5px 2px 5px 6px;
}
.v-select[dense].v-select[elevated] .vs__selected {
  font-size: 13px;
  --vs-line-height: 1.42;
  font-weight: 500;
  margin: 1px 2px 0;
}
.v-select[dense].v-select[elevated] .vs__search {
  font-size: 13px;
}
.v-select[rounded] {
  --vs-border-radius: 20px;
  --vs-border-color: transparent;
}
.v-select[rounded][alternative-indicator=true] .vs__open-indicator {
  fill: none;
  transition: none;
  --vs-controls-size: 0.8;
}
.v-select[outlined] {
  --vs-border-radius: 20px;
  --vs-border-color: rgb(var(--color-stroke));
}
.v-select[text] {
  --vs-border-radius: 0px;
  --vs-border-color: tranparent;
}
.v-select[text] .vs__dropdown-toggle {
  background: transparent;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
